module.exports = __webpack_public_path__ + "static/im-master-card-589803eee6c7fa5c2fd93d3306c24c95.png";